import React from "react";
import Loader from '../../../components/Loader';
import Page from '../../../components/Page';
import HTTPManager from "../../../utils/httpRequestManager";
import TableView from '../../../components/table/tableView';
import { toast, ToastContainer } from 'react-toastify';
import Iconify from '../../../components/Iconify';
import FormManager from "../../../components/formComponents/FormManager";
import schema from './schema.json';
import {Box, Grid, Card,  Container, Typography, Stack} from '@mui/material';
import FButton from '../../../components/formComponents/components/button';
import { checkButtonAccess } from "../../../utils/protector";

const getIcon = (name) => <Iconify icon={name} width={22} height={22} />;

export default class Agents extends React.Component{
    httpManager = new HTTPManager();

    constructor(){
        super();
        this.state={
            isLoading:false,
            schema:{},
            employeelist:[],
            addForm: false,
            selectedEmployee:{},
            columns:[
                {
                    field: 'firstName',
                    headerName: 'Name',
                    minWidth:200,
                    editable: false,
                    renderCell: (params) => (
                        <div>
                            {params.row.cnAgentFirstName === ''? '--' : params.row.cnAgentFirstName + ' ' + params.row.cnAgentLastName }
                        </div>
                    )
                },
                {
                    field: 'email',
                    headerName: 'Email',
                    minWidth:200,
                    editable: false,
                    renderCell: (params) => (
                        <div>
                           {params.row.cnAgentEmail === ''? '--' : params.row.cnAgentEmail}
                        </div>
                    )
                }, 
                {
                  field: 'passcode',
                  headerName: 'PassCode', 
                  editable: false,minWidth:100,
                  renderCell: (params) => (
                      <div>
                         {params.row.cnAgentCode === ''? '--' : params.row.cnAgentCode}
                      </div>
                  )
              },
                // {
                //     field: 'status',
                //     headerName: 'Status', 
                //     minWidth:100,
                //     editable: false,
                //     renderCell: (params) => (
                //        <div style={{textTransform:'capitalize'}}> 
                //             {params.row.cnAgentStatus === '1' ? 'Active' : 'Inactive'}
                //         </div>
                //     )
                // },
                {
                    field: 'Action',
                    headerName:'Actions',
                    flex:1,
                    minWidth:100,
                    renderCell: (params) => (
                        this.getActions(params)                    
                    ),
                }
                
            ],
        }
        this.handleCloseform = this.handleCloseform.bind(this);
        this.changePercentage = this.changePercentage.bind(this);
        this.updateRecord = this.updateRecord.bind(this);
        this.resendmail = this.resendmail.bind(this);
        this.onStateChange = this.onStateChange.bind(this);  
    } 

    onStateChange(values){
        this.httpManager.postRequest('lookup/getRegionByState', {stateId: values.cnAgentState}).then(response=>{
            var regionId = response.data.regionId ? response.data.regionId : ''
            //console.log(regionId)
                var schema = Object.assign({}, this.state.schema);
                var properties = Object.assign([], this.state.schema.properties);
                var props=[];
                properties.forEach((field,i)=>{
                    if(field.name === 'cnAgentRegion'){
                        field.value = regionId;
                    }
                    else{
                        field.value = values[field.name]
                    }
                    props.push(field);
                    if(i === properties.length-1){ 
                        schema.properties = props; 
                        //console.log(schema)
                        schema.force = true
                        this.setState({schema: schema},()=>{
                            this.setState({addForm: true})
                        })
                    }
                })
        })
    }

    resendmail(row){
        this.setState({isLoading: true}, ()=>{
            this.httpManager.postRequest(`common/resendMail`, {userType: "A", userId: row.id}).then(res=>{ 
                this.setState({isLoading: false});
                this.reloadData(res.message);
            })
        })
    }

    updateRecord(row, status){ 
        this.setState({isLoading: true}, ()=>{
            this.httpManager.postRequest(`cnAgents/updateAgent`, {cnAgentStatus: status, id: row.id}).then(res=>{
                //console.log(res.message);
                this.setState({isLoading: false});
                this.reloadData(res.message);
            })
        })
    }
    changePercentage(props, values){
        var schema = Object.assign({}, this.state.schema);
        var properties = Object.assign([], this.state.schema.properties);
        var schemaprops=[];
        properties.forEach((field,i)=>{
            if(props.name === 'cnAgentOwnerPercentage' && field.name === 'cnAgentPercentage'){ 
                field.value = 100 - Number(props.value); 
            }
            else if(props.name === 'cnAgentPercentage' && field.name === 'cnAgentOwnerPercentage'){ 
                field.value = 100 - Number(props.value);  
            }
            else{
                field.value = values[field.name]
            }
            schemaprops.push(field);
            if(i === properties.length-1){ 
                //console.log(schemaprops)
                schema.properties = schemaprops; 
                schema.force = true; 
                this.setState({schema: schema},()=>{
                    this.setState({addForm: true})
                })
            }
        });
    }
    componentDidMount(){ 
        this.setState({schema: schema},()=>{
            this.reloadData();
        })
    }

    handleCloseform(){
        this.setState({addForm: false})
    }


  getActions(params){
    var detail = window.localStorage.getItem('userdetail')
    if(detail !== '' && detail !== undefined && detail !=='{}'){
      var userdetail = JSON.parse(detail);
    return <div>       
            {userdetail.id !== params.row.id &&  checkButtonAccess('User.Agents') === 'W' &&
                <FButton permission_id = "web_edit_employee" permission_label="Show edit employee"
                variant="outlined" 
                size="small" 
                onClick={()=>this.openEdit(params.row)} 
                label="Edit"/>
            }
            {params.row.cnAgentStatus==='1' &&  userdetail.id !== params.row.id && checkButtonAccess('User.Agents') === 'W' &&
                <FButton permission_id = "web_status_employee" permission_label="Show status employee"
                variant="contained" 
                size="small" 
                onClick={()=>{this.updateRecord(params.row, 0)}} 
                label="Deactivate"/>
            }
            {params.row.cnAgentStatus==='0' && userdetail.id !== params.row.id && checkButtonAccess('User.Agents') === 'W' &&
                <FButton permission_id = "web_status_employee" permission_label="Show status employee"
                variant="contained" 
                size="small" 
                onClick={()=>{this.deleteRecord(params.row, 1)}} 
                label="Activate"/>
            }
            {params.row.isUserVerified!==1 && userdetail.id !== params.row.id && params.row.cnAgentEmail !== '' && params.row.cnAgentEmail !== null && checkButtonAccess('User.Agents') === 'W' &&
                <FButton permission_id = "web_resendmail_employee" permission_label="Show resendmail employee"
                variant="contained" 
                size="small" 
                onClick={()=>{this.resendmail(params.row)}} 
                label="Resend Email"/>
            }
            {(userdetail.id === params.row.id || checkButtonAccess('User.Agents') !== 'W' ) && <p style={{paddingLeft:'10px'}}>N/A</p> }   
        </div>
    }
    }

    openEdit(data){ 
        var schema = Object.assign({}, this.state.schema);
        var properties = Object.assign([], this.state.schema.properties);
        var props=[];
        properties.forEach((field,i)=>{
            field.value = data[field.name];
            props.push(field);
            if(i === properties.length-1){
                props.push({
                    "component":"TextField", 
                    "type": "hidden", 
                    "minLength": 1,
                    "maxLength": 50,
                    "grid":6,
                    "name":"id",
                    "label":"id",
                    "placeholder":"id",
                    "value":data.id
                  })
                schema.properties = props; 
                this.setState({schema: schema,selectedRegion: data},()=>{
                    this.setState({addForm: true})
                })
            }
        })
    }

    reloadData(msg=''){
        if(msg !== ''){ 
            toast.dismiss();
            toast.success(msg, {
                position: "top-center",
                autoClose: 5000,
                closeButton:false,
                hideProgressBar: true,
                closeOnClick: false,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        }
        this.setState({isLoading: true, addForm: false},()=>{
            this.httpManager.getRequest(`cnAgents/getAgents`).then(response=>{
                var data = [];
                if(response.data.length > 0){
                    response.data.forEach((elmt, i)=>{ 
                        elmt.id = elmt.cnAgentId;
                        data.push(elmt);
                        if(i === response.data.length-1){
                            this.setState({employeelist: data, isLoading: false});
                        }
                    })
                }
                else{
                    this.setState({employeelist: data, isLoading: false});
                }
            })
        })
    }

    openAdd(){
        this.setState({schema: schema,selectedEmployee: {}},()=>{
            var schemaobj = Object.assign({}, schema);

            var properties = Object.assign([], this.state.schema.properties);
            var props=[];
            properties.forEach((field,i)=>{
                delete field["value"];
                props.push(field);
                if(i === properties.length-1){
                    schemaobj.properties = props;
                }
            });
            this.setState({schema:schemaobj}, ()=>{
                this.setState({addForm: true}) 
            })
        })
    }

    render(){
        return <Page title="Castlenova Employees | Astro POS">
                {this.state.isLoading && <Loader show={this.state.isLoading} />}
                <ToastContainer
            position="top-center"
            autoClose={5000}
            hideProgressBar
            newestOnTop={false}
            closeOnClick={false}
            rtl={false}
            pauseOnFocusLoss={false}
            draggable={false}
            pauseOnHover={false}
            />

    {!this.state.addForm ? 
        <Container maxWidth="xl">
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
            <Typography variant="h4" gutterBottom>
              Agents
            </Typography>
            <FButton 
              onClick={()=>this.openAdd()}
              size="large"
              variant="contained"
              label="Add Agent"
              startIcon={getIcon('mdi:plus')}
            />
          </Stack>

          <Card>
              <TableView
              data={this.state.employeelist} 
              columns={this.state.columns} />
          </Card>
        </Container> : ''
        }
        {this.state.addForm && <Box sx={{ width: '100%' }}> 
                <Grid container spacing={3}  alignItems="center"  justifyContent="center" style={{marginLeft:0, marginRight:0,width:'100%', fontWeight:'bold'}} > 
                     <Grid item xs={12}> 
                        <Stack spacing={3}> 
                            <FormManager formProps={this.state.schema}  formFunctions={{
                                onStateChange: this.onStateChange,
                                changePercentage:  this.changePercentage 
                            }} reloadData={(msg)=>this.reloadData(msg)} closeForm={()=>this.handleCloseform()}/>
                        </Stack>
                    </Grid>
                </Grid>
            </Box>}
        </Page>
    }
}